"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCallbackQueryOrMutation = exports.dataReducer = void 0;
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const fetching_1 = require("./fetching");
const useClient_1 = require("./useClient");
const lib_1 = require("../lib");
exports.dataReducer = {
    SET_DATA: (_, data) => ({
        data,
        loading: false,
    }),
    SET_ERROR: (_, error) => ({ error, loading: false }),
    LOADING: () => ({ loading: true }),
    REFETCH: () => ({ refetchTrigger: {}, loading: true }),
    RESET: () => ({ data: undefined, error: undefined }),
};
function useCallbackQueryOrMutation(type, name, ...args) {
    const client = (0, useClient_1.useClient)();
    const [_a] = args, _b = _a === void 0 ? {} : _a, { fetchPolicy = 'networkOnly' } = _b, rest = __rest(_b, ["fetchPolicy"]);
    const argsRef = (0, react_1.useRef)();
    const options = Object.assign({ fetchPolicy }, rest);
    const fromCache = fetchPolicy === 'networkOnly'
        ? undefined
        : client === null || client === void 0 ? void 0 : client.queryCache(name, options);
    const [{ data, loading, error, refetchTrigger }, dispatch] = (0, lib_1.useReducer)(exports.dataReducer, {
        data: fromCache,
        loading: false,
    });
    (0, react_1.useEffect)(() => {
        if (type === 'query') {
            return client === null || client === void 0 ? void 0 : client.subscribeRefetchQueries(name, () => {
                if (argsRef.current) {
                    dispatch('REFETCH');
                }
            });
        }
    }, [client, name, type]);
    const serialized = (0, fetching_1.serialize)(type, name, options);
    const execute = (...params) => __awaiter(this, void 0, void 0, function* () {
        var _c;
        const operation = client[type === 'query' ? 'query' : 'mutate'];
        const res = yield operation(...params);
        if (rest === null || rest === void 0 ? void 0 : rest.onSuccess) {
            (_c = rest.onSuccess) === null || _c === void 0 ? void 0 : _c.call(rest, res);
        }
        dispatch('SET_DATA', res);
        return res;
    });
    const handler = (0, react_1.useCallback)((queryArgs) => __awaiter(this, void 0, void 0, function* () {
        dispatch('LOADING');
        try {
            const res = yield execute(name, Object.assign(Object.assign({}, options), { args: queryArgs }));
            argsRef.current = type === 'query' ? queryArgs || true : undefined;
            return res;
        }
        catch (error_) {
            if (typeof error_ === 'string' || error_ instanceof Error) {
                const msg = (0, utils_1.getErrorMessage)(error_);
                dispatch('SET_ERROR', msg);
                if (rest === null || rest === void 0 ? void 0 : rest.onError) {
                    rest.onError(msg);
                }
            }
            throw error_;
        }
    }), [serialized]);
    (0, react_1.useEffect)(() => {
        if (argsRef.current) {
            void execute(name, Object.assign(Object.assign({}, options), { args: argsRef.current === true ? undefined : argsRef.current, fetchPolicy: 'networkOnly' }));
        }
    }, [refetchTrigger]);
    const props = { data, error, loading };
    const iterator = function* () {
        yield handler;
        yield props;
    };
    props[Symbol.iterator] = iterator;
    const prox = new Proxy(handler, {
        get: (_, k) => props[k],
        apply: (obj, thisArg, argsList) => obj.apply(thisArg, argsList),
    });
    prox[Symbol.iterator] = iterator;
    return prox;
}
exports.useCallbackQueryOrMutation = useCallbackQueryOrMutation;
